<script>
  let {
    open = $bindable(false),
    title,
    tabs,
    width = "40rem",
    height = "auto",
    padding = "p-10",
    onClose,
    children,
    footerButtons,
    closeOnEscape = true,
    closeOnClickOutside = true,
  } = $props();

  let modalBg = $state(null)

  function requestClose() {
    // Ensure `bind:open` stays in sync even if a caller only passes `onClose`.
    open = false
    onClose?.()
  }

  // Portal the modal to <body> so it's not inside any transformed ancestor (e.g. Popper dropdown).
  $effect(() => {
    if (!open || !modalBg) return
    if (modalBg.parentNode !== document.body) document.body.appendChild(modalBg)
  })

  function handleKeydown(e) {
    if (!open) return
    if (closeOnEscape && e.key === "Escape") requestClose()
  }

  function handleClick(e) {
    if (!open) return
    if (closeOnClickOutside && e.target.classList?.contains("modal-bg")) requestClose()
  }
  
</script>

<svelte:window onkeydown={handleKeydown} onclick={handleClick} />

{#if open}
  <div class="modal-bg" bind:this={modalBg}>
    <section class="modal" style="width: {width}; height: {height}">
      {#if title || tabs}
        <div class="modal-header" class:with-tabs={tabs}>
          <h4 class="modal-title">{title}</h4>
          {#if tabs}
            <div class="modal-tabs">
              {@render tabs()}
            </div>
          {/if}
        </div>
      {/if}

      <main class={padding}>
        {@render children?.()}

        <footer class="modal-footer">
          <button class="button" type="button" onclick={requestClose}>Fermer</button>
          {@render footerButtons?.()}
        </footer>
      </main>
    </section>
  </div>
{/if}

